import React from 'react';

import { useGroupState, useGroupActions } from './GroupContext';
import { toggleFeature } from './restApi';
import Button from '../../Shared/UI/Button/components/Button';

import styles from './FeaturesSection.module.scss';

const FEATURE_DISPLAY_INFO = {
  job_prospects: {
    displayName: 'Job Prospects',
    description: 'Track and manage job prospects for group members.',
  },
};

const FeaturesSection = () => {
  const state = useGroupState();
  const { onResponse, onError } = useGroupActions();
  const availableFeatures = state?.group?.availableFeatures;

  if (!availableFeatures) return null;

  const groupId = state?.group?.id;
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  const handleToggle = (featureName) => {
    toggleFeature({
      id: groupId,
      onResponse,
      onError,
      body: { featureName, authenticityToken },
    });
  };

  return (
    <div className={styles.featuresSection}>
      <h3 className={styles.sectionTitle}>Features</h3>
      <p className={styles.sectionDescription}>
        Enable or disable features for this group. Disabling a feature removes it from the sidebar and revokes associated permissions.
      </p>
      <div className={styles.featureBlocks}>
        {availableFeatures.map((feature) => {
          const info = FEATURE_DISPLAY_INFO[feature.name] || {};
          return (
            <div key={feature.name} className={styles.featureBlock}>
              <div className={styles.featureInfo}>
                <div>
                  <h4 className={styles.featureName}>
                    {info.displayName || feature.name}
                  </h4>
                  <p className={styles.featureDescription}>
                    {info.description || ''}
                  </p>
                </div>
                <Button
                  variant={feature.enabled ? "destructive" : "primary"}
                  onClick={() => handleToggle(feature.name)}
                >
                  {feature.enabled ? 'Disable' : 'Enable'}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeaturesSection;
